export enum MessageTypeEnum {
  email = 1,
  sms = 2,
  emailab = 3
}
